<template>
  <section class="container" id="hpcta">
    <header class="circleHeader" v-if="siteInfo">
      <span v-html="siteInfo.homepageCTA.text"></span>
      <img v-if="siteInfo.homepageCTA.image" :src="siteInfo.homepageCTA.image.sizes.medium" alt="" />
    </header>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'call-to-action',
  props: ['content'],
  computed: {
    ...mapGetters([
      'siteInfo'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
@import ../../assets/styles/colors
@import ../../assets/styles/mixins

section#hpcta
  margin: 50px auto
  padding: 30px
  +desktop
    padding: 30px 0
  .circleHeader
    &:before
      background: $yellow
    img
      display: none
      margin-top: 35px
      margin-left: 35px
      max-height: 300px
      +smDesktop
        display: inline-block
    h2
      font-weight: bold
      font-size: 36px
      line-height: 46px
      +tablet
        width: 620px
      a
        color: inherit
        border-bottom: 2px solid 
        &:hover
          border-color: $yellow
</style>



// WEBPACK FOOTER //
// CallToAction.vue?7ca209e0